/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('#shopify-section-home_text_columns_33ANyD');
  if (!section || section.querySelector('.gidc-slider-controls')) return;

  var track = section.querySelector('.home-inline__items > .o-layout');
  if (!track) return;

  var slides = Array.prototype.slice.call(track.children);
  if (slides.length < 2) return;

  var controls = document.createElement('div');
  controls.className = 'gidc-slider-controls';
  controls.innerHTML = '<button class="gidc-slider-prev" type="button" aria-label="Previous item">&#8592;</button><div class="gidc-slider-dots" aria-hidden="true"></div><button class="gidc-slider-next" type="button" aria-label="Next item">&#8594;</button>';

  track.insertAdjacentElement('afterend', controls);

  var prev = controls.querySelector('.gidc-slider-prev');
  var next = controls.querySelector('.gidc-slider-next');
  var dotsWrap = controls.querySelector('.gidc-slider-dots');
  var current = 0;

  var dots = slides.map(function () {
    var dot = document.createElement('span');
    dot.className = 'gidc-slider-dot';
    dotsWrap.appendChild(dot);
    return dot;
  });

  function update(index) {
    current = Math.max(0, Math.min(index, slides.length - 1));
    prev.disabled = current === 0;
    next.disabled = current === slides.length - 1;

    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === current);
    });
  }

  function goTo(index) {
    update(index);
    track.scrollTo({
      left: slides[current].offsetLeft - slides[0].offsetLeft,
      behavior: 'smooth'
    });
  }

  prev.addEventListener('click', function () {
    goTo(current - 1);
  });

  next.addEventListener('click', function () {
    goTo(current + 1);
  });

  var ticking = false;

  track.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;

    window.requestAnimationFrame(function () {
      var nearest = 0;
      var distance = Infinity;

      slides.forEach(function (slide, index) {
        var slideDistance = Math.abs(
          slide.offsetLeft - slides[0].offsetLeft - track.scrollLeft
        );

        if (slideDistance < distance) {
          distance = slideDistance;
          nearest = index;
        }
      });

      update(nearest);
      ticking = false;
    });
  });

  update(0);
});